import { useCallback, useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { useDropzone } from "react-dropzone"
import { uploadImage } from "../../api/upload-files"
import { useRequestProcessor } from "../../api/requestProcessor"
import { getWorkshopsWithoutGallery, storeSingleGalleries } from "../../api/galleries"
import { domainName } from "../../constants/site"

const CreateGallery = () => {

    const [name, setName] = useState("")
    const [category, setCategory] = useState("workshop")
    const [selectedWorkshop, setSelectedWorkshop] = useState()
    const [gallery, setGallery] = useState([])

    const navigate = useNavigate()
    const { Query, Mutate } = useRequestProcessor()



    const { data:workshopsData, isLoading, isError } = Query(
        ['getAllWorkshopWithoutGallery'],
        () => getWorkshopsWithoutGallery(),
    );


    const { mutate: mutateGallery } = Mutate(
        "uploadgalleryImage",
        uploadImage,
        {
            onSuccess: (data) => {
                toast.success("عکس با موفقیت آپلود شد", {
                    autoClose: 2500,
                    progress: false,
                })
                setGallery(prev => [...prev, {
                    thumb: data.images.thumb
                }])
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );


    const { mutate: storeGallery } = Mutate(
        "storeGallery",
        storeSingleGalleries,
        {
            onSuccess: (data) => {
                toast.success(data.message + " تا چند ثانیه دیگر به صفحه اصلی منتقل خواهی شد.", {
                    autoClose: 2500,
                    progress: false,
                })
                setTimeout(() => { navigate("/admin/galleries") }, 3000)
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );


    // DROPZONE CONFIG

    const onDrop = useCallback(acceptedFiles => {
        for (let files of acceptedFiles) {
            let formData = new FormData();
            formData.append("images", files)
            mutateGallery(formData)
        }
    }, [])




    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop, accept: {
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
        }
    })





    async function onSubmitHandler(e) {
        e.preventDefault();
        let data = {
            title: name,
            gallery_type: category,
            gallery_type_id:selectedWorkshop,
            gallery_images:gallery
        }
        storeGallery(data)
        // await storeSingleCategories(data).then(res => res.message === "دسته بندی با موفقیت ساخته شد." ? successfulHandler(res) : errorHandler(res.errors))
    }

    return (
        <Layout >
            <MainPageLayout backButton sectionTitle={"مشخصات گالری :"} title={"ایجاد گالری جدید"} >
                <form onSubmit={onSubmitHandler}>
                    <div className="flex">
                        <div className='flex flex-col my-4 w-full'>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>نام گالری :</p>
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} className=' form-input !w-3/4' placeholder='نام گالری' />
                            </div>
                            <div className="flex flex-col my-3">
                                <p className='pr-3 pb-1'>دسته بندی گالری :</p>
                                <select value={category} onChange={e => setCategory(e.target.value)} className="!w-3/4 wsm:!w-full border border-gray-500 py-[10px] px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                    <option selected disabled hidden>انتخاب نوع دسته بندی</option>
                                    {/* <option value={"blog"} >بلاگ</option> */}
                                    <option value={"workshop"} >ورک شاپ</option>
                                </select>
                            </div>
                            <div className="flex flex-col my-3">
                                <p className='pr-3 pb-1'>انتخاب ورک شاپ :</p>
                                <select value={selectedWorkshop} onChange={e => setSelectedWorkshop(e.target.value)} className="!w-3/4 wsm:!w-full border border-gray-500 py-[10px] px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                    <option selected disabled hidden>انتخاب نوع دسته بندی</option>
                                    {/* <option value={"blog"} >بلاگ</option> */}
                                    {
                                        workshopsData?.data?.map( el => (
                                            
                                            <option value={el.id} >{el.title}</option>
                                        ))
                                    }
                                    {/* <option value={"workshop"} >ورک شاپ</option> */}
                                </select>
                            </div>
                        </div>
                        <div className="w-full">
                            <div className="flex flex-col mr-3 mb-6">
                                <p className='pr-3 pb-1'>انتخاب عکس های گالری :</p>

                                <form id='recommendationDiv' className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getRootProps()}>
                                    <input
                                        {...getInputProps()} />
                                    {
                                        <p> فایل ها را انتخاب یا به اینجا بکشید</p>
                                    }
                                </form>
                                <div className='!grid grid-cols-4 mt-4 [&>*:nth-child(1)]:border-b [&>*:nth-child(2)]:border-b [&>*:nth-child(3)]:border-b [&>*:nth-child(4)]:border-b'>
                                    {
                                        gallery.map(el => (
                                            <div className="w-full bg-gray-100  justify-center items-center">
                                                <img src={domainName + el.thumb} alt="" />
                                            </div>
                                        ))
                                    }


                                    {/* <div className="w-full bg-gray-100  justify-center items-center galleryImage_list">
                                        <div className=" galleryCard__background blur-sm !grayscale !rounded-none bg-[url(https://images.freeimages.com/images/large-previews/321/sunflower-in-bulgaria-1641774.jpg)]" >
                                        </div>
                                        <p className="text-white  absolute top-0 w-full flex justify-center items-center h-full">
                                            18+ عکس دیگر
                                        </p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default CreateGallery